'use client';

import { useTranslation } from '@/context/LanguageContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faAward, faBookOpen, faUsers } from '@fortawesome/free-solid-svg-icons';
import { useSettings } from '@/context/SettingsContext';

// Default data for Agribisnis if no settings found
const defaultCompetencies = [
  {
    icon: faAward,
    titleId: 'Unggul & Berdaya Saing',
    titleEn: 'Excellence & Competitiveness',
    descriptionId: 'Menghasilkan lulusan yang kompeten dan mampu bersaing di tingkat nasional maupun internasional.',
    descriptionEn: 'Producing competent graduates capable of competing at national and international levels.'
  },
  {
    icon: faBookOpen,
    titleId: 'Kurikulum Berbasis KKNI',
    titleEn: 'KKNI-Based Curriculum',
    descriptionId: 'Mendukung program Merdeka Belajar Kampus Merdeka (MBKM) dengan kurikulum yang relevan dengan industri.',
    descriptionEn: 'Supporting the Independent Learning Campus program (MBKM) with an industry-relevant curriculum.'
  },
  {
    icon: faUsers,
    titleId: 'Jaringan Luas',
    titleEn: 'Wide Network',
    descriptionId: 'Kerjasama dengan berbagai instansi pemerintah, perusahaan swasta, dan institusi pendidikan lainnya.',
    descriptionEn: 'Partnerships with various government agencies, private companies, and other educational institutions.'
  },
  {
    icon: faCheckCircle,
    titleId: 'Akreditasi Unggul',
    titleEn: 'Excellent Accreditation',
    descriptionId: 'Program studi telah terakreditasi dengan predikat yang memuaskan.',
    descriptionEn: 'The study program has been accredited with a satisfactory rating.'
  }
];

export default function CompetenceSection() {
  const { language } = useTranslation();
  const { getSettingContent } = useSettings();

  // In a real implementation, we would fetch these from settings or an API
  // For now we use static defaults tailored for Agribisnis
  const items = defaultCompetencies;

  return (
    <section id="competence" className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16" data-aos="fade-up">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-unmulDarkGreen">
            {language === 'en' ? (
              <>STUDY PROGRAM <span className="text-unmulYellow">EXCELLENCE</span></>
            ) : (
              <>KEUNGGULAN <span className="text-unmulYellow">PROGRAM STUDI</span></>
            )}
          </h2>
          <p className="text-gray-600 mt-4 max-w-3xl mx-auto text-lg">
            {language === 'en' 
              ? 'Why choose to join us? Here are some of the main advantages of our study program.'
              : 'Mengapa memilih bergabung dengan kami? Berikut adalah beberapa keunggulan utama program studi kami.'}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {items.map((item, index) => (
            <div 
              key={index} 
              className="bg-gray-50 p-8 rounded-xl hover:shadow-xl transition duration-300 border border-gray-100 group"
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div className="w-16 h-16 bg-unmulPale text-unmulGreen rounded-full flex items-center justify-center text-2xl mb-6 group-hover:bg-unmulGreen group-hover:text-white transition duration-300">
                <FontAwesomeIcon icon={item.icon} />
              </div>
              <h3 className="text-xl font-bold text-unmulDarkGreen mb-4">
                {language === 'en' ? item.titleEn : item.titleId}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {language === 'en' ? item.descriptionEn : item.descriptionId}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
